module.exports = __webpack_public_path__ + "img/icon1.89c85488.png";